import { render, staticRenderFns } from "./GalleryVideo.vue?vue&type=template&id=0d2fc5f0&"
import script from "./GalleryVideo.vue?vue&type=script&lang=js&"
export * from "./GalleryVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports